import React, { useEffect } from 'react';
import UIButton from 'Components/UIComponents/UIButton';
import { discountPlanPrices, PlanDurations } from 'Interfaces/Billing';
import dayjs from 'dayjs';
import { formatDateToStringForTrialInfo } from 'Utils/formatters';
import History from 'Services/History';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';
import { useSelector } from 'react-redux';
import { selectUserPlan } from 'Utils/selectors';
import SuccessPageWrapper from 'Layouts/SuccessPageWrapper';
import { RouteChildrenProps, useLocation } from 'react-router-dom';
import { useShowPlanUpgradeSuccessPageChange } from 'Hooks/Auth';

interface ChangePlanSuccessProps {
  successRequired?: boolean;
}

const changePlanSuccessPathRegEx = /\/((business|personal)-start|welcome-(business|personal))$/;

type PlanTypeContext = { planType: string };

function ChangePlanSuccess({ match }: RouteChildrenProps<PlanTypeContext>) {
  const location = useLocation<ChangePlanSuccessProps>();

  const [changeShowPlanUpgradeSuccessPage] = useShowPlanUpgradeSuccessPageChange();
  const plan = useSelector(selectUserPlan);

  const planType = match?.params.planType;

  if (!location?.state?.successRequired) History.push(AuthorizedRoutePaths.BASE_PATH);

  const price = discountPlanPrices[plan.type][plan.duration];
  const nextBillingDate = dayjs(new Date())
    .add(plan.duration === PlanDurations.MONTHLY ? 1 : 12, 'month')
    .format('MMMM D, YYYY');

  const handleContinue = () => {
    History.replace(AuthorizedRoutePaths.SETTINGS_BILLING);
  };

  useEffect(() => {
    changeShowPlanUpgradeSuccessPage(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!planType || !changePlanSuccessPathRegEx.test(History.location.pathname)) {
      History.push(AuthorizedRoutePaths.BASE_PATH);
    }
  }, [planType]);

  return (
    <SuccessPageWrapper location={location}>
      <div className="successPages__inner">
        <div className="successPages__wrapper">
          <p className="successPages__header">Thank you for signing up! 🎉</p>
          <p className="successPages__text">
            We&apos;re so excited to have you with us. Your subscription starts today and
            will automatically renew on{' '}
            <b>{formatDateToStringForTrialInfo(nextBillingDate)}</b> at{' '}
            <b>${price}/month</b>.
          </p>
          <p className="successPages__text">
            Want to make changes? You’re always in control through your account settings.
          </p>
          <UIButton
            priority="primary"
            title={'Continue'}
            handleClick={handleContinue}
            className="successPages__button--download"
          />
        </div>
      </div>
    </SuccessPageWrapper>
  );
}

export default ChangePlanSuccess;
